import React, { useState, useCallback, useEffect } from "react";
import { Form, Button, Row } from "react-bootstrap";
import { useConversations } from "../contexts/ConversationsProvider";
import {
  IoSend,
  IoArrowBackOutline,
  IoMic,
  IoPause,
  IoTrash,
  IoPlay,
} from "react-icons/io5";
import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
import { useContacts } from "../contexts/ContactsProvider";
function isDateToday(messageDate) {
  const today = new Date();
  const isToday =
    messageDate.getDate() === today.getDate() &&
    messageDate.getMonth() === today.getMonth() &&
    messageDate.getFullYear() === today.getFullYear();

  return isToday;
}

function formatDate(dateString) {
  const date = new Date(dateString);

  const isoString = date.toISOString();

  const [datePart, timePart] = isoString.split("T");
  const [year, month, day] = datePart.split("-");
  const [hour, minute, second] = timePart.split(":");
  const seconds = second.split("Z")[0];
  const messageDate = new Date(
    Date.UTC(year, month - 1, day, hour, minute, seconds)
  );

  const isToday = isDateToday(messageDate);
  let formattedDate;

  if (isToday) {
    formattedDate = messageDate.toLocaleTimeString([], {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  } else {
    formattedDate = messageDate.toLocaleDateString([], {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    formattedDate +=
      ", " +
      messageDate.toLocaleTimeString([], {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
  }

  return formattedDate;
}

export default function OpenConversation({ id, chatid, setIsSelect }) {
  const {
    startRecording,
    stopRecording,
    togglePauseResume,
    recordingBlob,
    isRecording,
    isPaused,
    recordingTime,
    mediaRecorder,
  } = useAudioRecorder();

  const [text, setText] = useState("");
  const setRef = useCallback((node) => {
    if (node) {
      node.scrollIntoView({ smooth: true });
    }
  }, []);

  const { contacts } = useContacts();
  const { sendMessage, selectedConversation, quickResponses } =
    useConversations();

  function handleQuickResponseSubmit(quickText) {
    const date = new Date();
    const isoString = date.toISOString();
    sendMessage(chatid, quickText, date, "text");
    setText("");
  }

  function handleSubmit(e) {
    e.preventDefault();
    const date = new Date();
    //const isoString = date.toISOString();
    //sendMessage(chatid, text, date, "text");

    if (text) {
      sendMessage(chatid, text, date, "text");
    }

    // if (recordingBlob) {
    //   console.log("Stopping Recording");
    //   console.log("Sending that data to server");
    //   console.log(recordingBlob);
    //   stopRecording();
    //   sendMessage(chatid, ".", date, "audio", recordingBlob);
    // } else {
    //   if (text) {
    //     sendMessage(chatid, text, date, "text");
    //   }
    // }

    setText("");
  }
  const recorderControls = useAudioRecorder();
  const addAudioElement = (blob) => {
    //stopRecording();
    const url = URL.createObjectURL(blob);
    const audio = document.createElement("audio");
    audio.src = url;
    audio.controls = true;
    document.body.appendChild(audio);
  };

  const createAudioBlob = (bytearray) => {
    console.log("TRYING TO SEE BYTE ARRAY INTO BLOB");
    try {
      console.log("TRYING TO SEE BYTE ARRAY INTO BLOB");
      const base64String = bytearray;
      const binaryString = atob(base64String); // Convert base64 to binary
      const byteArray = new Uint8Array(binaryString.length);

      for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([byteArray], { type: "audio/webm;codecs=opus" });

      console.group("Bytes stuff");
      console.log(bytearray);
      console.log(base64String);
      console.log(binaryString);
      console.log(blob);
      console.groupEnd();
      const audioUrl = URL.createObjectURL(blob);

      // Set the audioUrl to your audio element
      const audioElement = document.getElementById("audioElement");
      audioElement.src = audioUrl;
    } catch (error) {
      console.error("Error creating audio blob: ", error);
    }
  };

  var contactIndex = -1;
  if (selectedConversation.isGroup == false) {
    const recepientIndex = selectedConversation.recipients.findIndex(
      (user) => user.id !== id
    );
    contactIndex = contacts.findIndex(
      (user) => user.id === selectedConversation.recipients[recepientIndex].id
    );
  }

  return (
    <div
      className="d-flex flex-column flex-grow-1"
      style={{
        backgroundColor: "var(--medium)",
        height: "100vh",
        width: "100vw",
        backgroundImage: "url(./pattern-background-1.png)",
      }}
    >
      {/* Header area */}
      <div
        className="d-flex justify-content-center"
        style={{ height: "20%", width: "100%", marginTop: "1rem" }}
      >
        <div
          className="bg-light border-bottom px-4 d-flex flex-row align-items-center"
          style={{
            width: "97%",
            height: "100%",
            backgroundColor: "#FAFAFA",
            borderRadius: "1rem",
            boxShadow: "0.5em 0.5px 5px var(--medium)",
          }}
        >
          <Button
            style={{
              backgroundColor: "var(--light)",
              border: "none",
              right: "0",
              paddingTop: "0",
              paddingBottom: "0",
              height: "50%",
            }}
            onClick={() => setIsSelect(false)}
          >
            <IoArrowBackOutline
              style={{ transform: "rotate(180deg)" }}
              color="var(--dark)"
            />
          </Button>
          <div className="mx-2 d-flex flex-column align-content-center">
            {contactIndex !== -1 && contacts[contactIndex].image !== "" ? (
              <img
                src={contacts[contactIndex].image}
                className="chat-profile-image"
                alt={"chat-image"}
              />
            ) : (
              <img
                src={"./blank-user-image.png"}
                className="chat-profile-image"
                alt={"chat-image"}
              />
            )}
          </div>
          <div>
            {selectedConversation.chatName ? (
              <div className="text-uppercase font-weight-bold">
                {selectedConversation.chatName}
              </div>
            ) : (
              ""
            )}
          </div>
          {selectedConversation.isGroup && (
            <div className="d-flex flex-grow-1 justify-content-end">
              <div
                className="d-flex flex-row justify-content-center align-items-center"
                style={{ textAlign: "center", fontSize: "0.9rem" }}
              >
                {selectedConversation.recipients.map((r, index) => {
                  const contactIndex = contacts.findIndex(
                    (user) => user.id === r.id
                  );

                  if (
                    contactIndex !== -1 &&
                    contacts[contactIndex].image !== ""
                  ) {
                    return (
                      <img
                        alt={"group-user-image-" + index}
                        key={"group-user-image" + index}
                        src={contacts[contactIndex].image}
                        className="recipients-profile-image"
                        style={{
                          zIndex: index,
                          left: `${4 * index}px`, // Set the left property based on the index
                          // left: index == 0 ? "-5px" : "0px",
                        }}
                      />
                    );
                  } else {
                    return (
                      <img
                        alt={"members-images-" + index}
                        key={"image-" + index}
                        src={"./blank-user-image.png"}
                        className="recipients-profile-image"
                        style={{
                          zIndex: index,
                          left: `${4 * index}px`, // Set the left property based on the index
                          // left: index == 0 ? "-5px" : "0px",
                        }}
                      />
                    );
                  }
                })}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Chat area */}
      <div
        className="flex-grow-1 overflow-auto"
        style={{
          height: "100%",
          marginTop: "0.5rem",
          marginBottom: "0.5rem",
          // marginBottom: quickResponses.length > 0 ? "220px" : "100px",
        }}
      >
        <div className="d-flex flex-column align-items-start justify-content-end px-2">
          {selectedConversation?.messages.map((message, index) => {
            const messageDate = formatDate(message.date);

            const lastMessage =
              selectedConversation.messages.length - 1 === index;
            return (
              <div
                ref={lastMessage ? setRef : null}
                key={index}
                className={`my-1 d-flex ${
                  message.fromMe
                    ? "align-self-end align-items-center flex-row-reverse"
                    : "align-items-center flex-row"
                }`}
                style={{ maxWidth: "80%" }}
              >
                <div className="mx-2 d-flex flex-column align-content-center">
                  <img
                    alt={"user-chat-image-" + index}
                    src={"./blank-user-image.png"}
                    width="40px"
                    style={{ borderRadius: "50%" }}
                  />
                </div>

                <div
                  className="d-flex flex-column"
                  style={{ minWidth: "200px" }}
                >
                  <div
                    className="px-3 py-2 mt-2"
                    style={{
                      backgroundColor: message.fromMe
                        ? "var(--primary-light)"
                        : "var(--light)",
                      borderRadius: "15px",
                    }}
                  >
                    <div className={`small d-flex flex-row `}>
                      <div className="app-bold">
                        {message.fromMe ? "You" : message.senderName}
                      </div>
                    </div>
                    {message.type == "text" && message.text}
                    {message.type === "audio" && (
                      <>
                        {/* <button onClick={createAudioBlob(message.byteArray)}>
                          Create Audio Blob
                        </button>

                        <audio controls id="audioElement">
                          Your browser does not support the audio element.
                        </audio> */}
                        <audio controls>
                          <source src={message.byteArray} type="audio/mp3" />
                          Your browser does not support the audio element.
                        </audio>
                      </>
                    )}

                    {/* {message.text} */}
                    <div
                      className="pt-1 d-flex justify-content-end"
                      style={{ fontSize: "0.8rem" }}
                    >
                      {messageDate}
                    </div>
                    <div
                      className="pt-1 d-flex justify-content-end"
                      style={{ fontSize: "0.8rem" }}
                    >
                      {/* {message.type} */}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Quick Response area */}
      {quickResponses.responses !== null && (
        <div
          className="d-flex justify-content-center"
          style={{ width: "100%", marginBottom: "1rem" }}
        >
          <div
            className="d-flex flex-column "
            style={{
              width: "95vw",
              height: "100%",
            }}
          >
            <Row
              xs={2}
              s={3}
              md={4}
              xl={5}
              className="d-flex justify-content-center"
            >
              {quickResponses.map((response) => {
                if (response !== "" && response !== null)
                  return (
                    <div className="p-1">
                      <Button
                        style={{
                          backgroundColor: "var(--light)",
                          border: "none",
                          height: "3em",
                          color: "var(--dark)",
                          width: "100%",
                          borderRadius: "1rem",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                        onClick={() => handleQuickResponseSubmit(response)}
                      >
                        {response}
                      </Button>
                    </div>
                  );
              })}
            </Row>
          </div>
        </div>
      )}

      {/* Input area */}
      <div
        className="d-flex justify-content-center"
        style={{ height: "20%", width: "100%", marginBottom: "1rem" }}
      >
        <Form onSubmit={handleSubmit} style={{ width: "97%", height: "100%" }}>
          <Form.Group
            className="d-flex flex-row mb-0 align-items-center"
            style={{}}
          >
            <Form.Control
              as="textarea"
              placeholder="اكتب رسالة..."
              className="d-flex justify-content-end"
              value={text}
              onChange={(e) => setText(e.target.value)}
              style={{
                width: "100%",
                minHeight: "20%",
                resize: "none",
                backgroundColor: "rgba(0, 0, 0, 0.0)",
                border: "none",
                margin: "1%",
                marginRight: "2%",
                boxShadow: "none",
                padding: "1.5%",
                backgroundColor: "var(--light)",
                borderRadius: "2rem",
                boxShadow: "0.5em 0.5px 5px var(--medium)",
              }}
            />
            {/* <AudioRecorder
              onRecordingComplete={addAudioElement}
              audioTrackConstraints={{
                noiseSuppression: true,
                echoCancellation: true,
              }}
              downloadOnSavePress={false}
              downloadFileExtension="webm"
              showVisualizer={true}
              style={{
                backgroundColor: "#f0f0f0",
                border: "1px solid #ccc",
                borderRadius: "5px",
                padding: "10px",
              }}
              buttonStyle={{
                backgroundColor: "#ff5733",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
              }}
            /> */}

            {/* {isRecording ? (
              <>
                <Button
                  style={{
                    backgroundColor: "var(--lightGray)",
                    border: "none",
                    right: "0",
                    height: "50%",
                    marginRight: "1%",
                    borderRadius: "50%",
                  }}
                  onClick={stopRecording}
                >
                  <IoTrash />
                </Button>
                {`${Math.floor(recordingTime / 60)}:${(
                  "0" +
                  (recordingTime % 60)
                ).slice(-2)}`}

                <Button
                  style={{
                    backgroundColor: "var(--lightGray)",
                    border: "none",
                    right: "0",
                    marginRight: "1%",
                    marginLeft: "1%",
                    borderRadius: "50%",
                  }}
                  onClick={togglePauseResume}
                >
                  {isPaused ? <IoPlay /> : <IoPause />}
                </Button>
              </>
            ) : (
              <Button
                style={{
                  backgroundColor: "var(--lightGray)",
                  border: "none",
                  right: "0",
                  marginRight: "1%",
                  borderRadius: "50%",
                }}
                onClick={startRecording}
              >
                <IoMic />
              </Button>
            )} */}

            <Button
              type="submit"
              style={{
                backgroundColor: "var(--lightGray)",
                border: "none",
                right: "0",
                marginRight: "2%",
                borderRadius: "50%",
              }}
            >
              <IoSend style={{ transform: "rotate(180deg)" }} />
            </Button>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
}
